import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BookingItem } from '@fry/booking/lib/booking-items';

import { EditorBookingItemTreeDataEditStore } from '../editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    selector: 'eas-editor-booking-item-root-edit',
    templateUrl: './editor-booking-item-root-edit.component.html',
    styleUrls: ['./editor-booking-item-root-edit.component.css'],
    standalone: false
})
export class EditorBookingItemRootEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  bookingItem: BookingItem;
  patchingItemTreeForm: FormGroup;
  replacingItem: EditorBookingItem;
  patchingItem: EditorBookingItem;
  patchingItemForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditorBookingItemRootEditComponent>,
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {
    this.patchingItem = null;
  }

  ngOnInit() {
    this.itemTreeStore.bookingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingItem => this.bookingItem = bookingItem);

    this.itemTreeDataEditStore.patchingItemTreeForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItemTreeForm => this.patchingItemTreeForm = patchingItemTreeForm);

    this.itemEditStore.replacingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(replacingItem => this.replacingItem = replacingItem);

    this.itemEditStore.patchingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItem => this.patchingItem = patchingItem);

    this.itemEditStore.patchingItemForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItemForm => this.patchingItemForm = patchingItemForm);
  }

  ngOnDestroy() {
    this.itemTreeDataEditStore.stopEditing();
    this.itemEditStore.stopEditing();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    this.itemTreeDataEditStore.save();
    this.itemEditStore.save(this.patchingItem.id);
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  onCancel() {
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  getPatchingItemTreeFormControl(key: string): FormControl {
    return this.patchingItemTreeForm.get(key) as FormControl;
  }

  getPatchingItemFormControl(key: string): FormControl {
    return this.patchingItemForm.get(key) as FormControl;
  }

  getPatchingItemFormArray(key: string): FormArray {
    return this.patchingItemForm.get(key) as FormArray;
  }

  getPatchingItemFormArrayFormGroup(key: string, index: number): FormGroup {
    return this.getPatchingItemFormArray(key).at(index) as FormGroup;
  }
}
